module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UwIrJj/tc-custom/9789948812173.jpg?1673614532",
      "alt": "This image is the cover for the book 964"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("964\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("هاشم الهاشم، عراقي ويحمل جنسيَّةً ألمانيَّةً، غادَر بلده العراق قبل سنواتٍ، واستقرَّ في ألمانيا عند خاله، وبعد فترةٍ انفصل عن عمل العائلة، وبدأ بتِجارته الخاصَّة. اليوم أصبح هاشم في الأربعين مِن عُمره، لَم يتغيَّر كثيرًا عمَّا كان عليه قبل خمس عشرة سنةً، غير أنَّ الزَّمن ترك على جسده بعض آثاره، مثل فقدان الحركة في إحدى أصابع يده اليُسرى بعد أن أُصيب برصاصةٍ في يده، وتغيَّر لون شَعره الأسوَد بعد أن غزَتِ الخُصَل البيضاء رأسه، وأصبح اللَّون الرَّماديُّ طاغيًا مع احتفاظه بكثافته، ومع بعض العلامات التي اكتسبها في مُواجهاته المباشِرة مع مُنافسيه، وقد ترك بعضُ خصومه آثارَهم على وجهه وفي أماكنَ متفرِّقةٍ في جسده، وعجزَتِ السَّنوات عن مسح آثار تلك النُّدوبِ مِن جِسمه ومِن ذاكِرته.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      شمسة المازمي\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0